<template>
    <MypageVisit
        :page_title="page_title"
        :icon_class="icon_class"
        :show_error.sync="show_error"
        :error_message="error_message"
        :error_level="error_level"
        :my_page_btn_flg="my_page_btn_flg"
        :add_dia_log.sync="add_dia_log"
        :add_dia_log_message="add_dia_log_message"
        :add_dia_log_doing="add_dia_log_doing"

        :golf_course="golf_course"
        :show_golf_list_flg="show_golf_list_flg"
        :selectGolf="selectGolf"
        :show_golf_list_count_flg="show_golf_list_count_flg"
    >
        <!-- 以下内容 -->
        <div class="col-sm-12 p-0">
            <div v-show="main_show" class="px-2">
                <div v-html="reservation_info" ref="addHtml">
                </div>
                <button
                    type="button"
                    class="my-3 bluebackbutton footer-btn-size"
                    @click="saveProce">
                    確認
                </button>
            </div>

            <div v-show="sub_show" class="px-2">
                <div v-html="confirmation_page" ref="addHtmlSub">
                </div>
                <button
                    type="button"
                    class="mt-3 bluebackbutton footer-btn-size"
                    @click="saveProce">
                    確認
                </button>
                <button
                    type="button"
                    class="my-3 mypagebackbutton footer-btn-size"
                    @click="backPage">
                    戻る
                </button>
            </div>

            <div v-show="is_show">

                <div class="qr-code" v-html="qr_code"></div>
                <div class="barcode" v-show="barcode_show">
                    <svg id="barcode"></svg>
                </div>

                <button
                    type="button"
                    class="my-3 mypagebackbutton footer-btn-size"
                    @click="myPage">
                    マイページトップに戻る
                </button>
            </div>
        </div>
    </MypageVisit>
</template>

<script>
/**
 * マイページ チェックイン画面
 * */
// 共通画面項目
import MypageVisit from '../components/MyPage/MypageVisit';
// 共通JS項目
import mypageVisitMixin from '../../mixins/MyPage/mypageVisitMixin.js';
import { CODE_MASTER } from '../../config.js';
import { GET_API } from '../../constants/mypage_visit';
import validater from "../../lib/validater";

export default {
    components: {
        MypageVisit,
        validater
    },
    mixins: [
        mypageVisitMixin
    ],
    data () {
        return {
            // API情報取得
            get_api_url : 'get_reservation_info',
            save_api_url : 'save_confirm_item',
            api_url: '',
            get_api_url_all : '',
            save_api_url_all : '',
            // 入力項目格納
            general_item_list: {
            },
            // 画面表示項目
            reservation_info: '',
            main_show: false,
            is_show: false,
            // サブ画面
            confirmation_page_list: [],
            confirmation_page: '',
            sub_count: -1,
            sub_show: false,
        };
    },
    // 画面作成前
    created () {
        this.page_title = 'チェックイン';
        this.icon_class = 'icon-icon-info-profile mypage-title-icon';
    },
    // 画面値更新時
    computed: {
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            // 約情報確認API URL取得
            if(this.json_info[this.get_api_url].length > 0){
                this.get_api_url_all = this.api_url + this.json_info[this.get_api_url];
            }
            // 確認項目保存API URL取得
            if(this.json_info[this.save_api_url].length > 0){
                this.save_api_url_all = this.api_url + this.json_info[this.save_api_url];
            }

            if(this.api_url != false){
                // データ取得
                this.getData();
            }
        },
        /** ----------------------------------------------
         * APIを使用し、データを取得
         * ---------------------------------------------- */
        getData: async function(){
            // ローディング表示
            this.$store.commit("loading/setIsOpacityLoading", true);

            // 送信データ
            var postData = {
                "OfficeCode" : this.api_office_code,
                "WebMemberID" : this.member_number
            };

            // 表示
            this.main_show = true;

            // APIでデータ送信する
            await this.$apollo.query({
                query: GET_API,
                variables: {
                    url: this.get_api_url_all,
                    key: this.api_key,
                    data: JSON.stringify(postData),
                }
            })
            // JSON型で取得
            .then(response => {
                var data = response.data.GetMypageVisitApi.data;
                return JSON.parse(data);
            })
            .then(data => {
                if(data.Result.Status == '1'){
                    // 画面入力値格納配列
                    if(data.GeneralItemList != undefined && data.GeneralItemList.length > 0){
                        var arry = [];
                        for(var val in data.GeneralItemList){
                            if(data.GeneralItemList[val]['GeneralItemName'] != undefined){
                                arry[data.GeneralItemList[val]['GeneralItemName']] = '';
                            }
                        }
                        this.general_item_list = arry;
                    }

                    // 画面表示
                    if(data.ReservationInfo != undefined && data.ReservationInfo.length > 0){
                        this.reservation_info = data.ReservationInfo;
                    }

                    // サブ画面表示
                    if(data.ConfirmationPageList != undefined && data.ConfirmationPageList.length > 0){
                        this.confirmation_page_list = data.ConfirmationPageList;
                    }

                // 既に確認済
                } else if(data.Result.Status == '2'){
                    // 表示コード種類設定
                    //this.make_display_code = '0';

                    // 表示コード生成 (両方表示)
                    // if(this.make_display_code == '0'){
                        // バーコード
                        this.makeDisplayBarCode(this.member_number);
                    //}else{
                        // QRコード
                        this.makeDisplayQrCode(this.member_number);
                    //}

                    this.main_show = false;
                    this.is_show = true;

                // その他、メッセージがある場合
                } else if(data.Result.Message !== undefined && data.Result.Message !== null){
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message =  data.Result.Message ;
                    this.error_level = "crit";

                // その他（システムエラー・サーバーエラー等）
                }else{
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                    this.error_level = "crit";
                }
            })
            .then(data => {
                // ローディング非表示
                this.$store.commit("loading/setIsOpacityLoading", false);
            })
            .catch((e) => {
                console.log(e)  //エラーをキャッチし表示
                // メッセージ表示
                this.show_error = true;
                this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。.";
                this.error_level = "crit";
                // ローディング非表示
                this.$store.commit("loading/setIsOpacityLoading", false);
            });

            // イベント作成
            this.htmlEventSet('addHtml');
        },
        /** ----------------------------------------------
         * 戻るボタン押下
         * ---------------------------------------------- */
        backPage: function(){

            // ローディング表示
            this.$store.commit("loading/setIsOpacityLoading", true);

            Promise.resolve()
                .then(function(){
                    return new Promise(function(fulfilled, rejected){
                        // サブ画面が設定されている場合描画
                        if(this.confirmation_page_list != undefined && this.confirmation_page_list.length > 0){
                            this.sub_count --;

                            // 存在チェック
                            if(this.confirmation_page_list[this.sub_count] != undefined && this.confirmation_page_list[this.sub_count].ConfirmPage != undefined){
                                // 表示する値変更
                                this.confirmation_page = this.confirmation_page_list[this.sub_count].ConfirmPage;
                                return fulfilled(false);
                            }else{
                                // 表示
                                this.sub_show = false;
                                this.main_show = true;
                            }
                        }
                        return fulfilled(true);
                    }.bind(this))
                }.bind(this))
                .then(confirmation_check => {
                    // サブ画面の表示フラグ
                    if(confirmation_check == false){
                        // イベント作成
                        this.htmlEventSet('addHtmlSub');
                        return;
                    }
                }).then(function(){
                    // ローディング削除
                    this.$store.commit("loading/setIsOpacityLoading", false);
                }.bind(this));
        },
        /** ----------------------------------------------
         * 確認ボタン押下
         *  確認項目保存APIを実行
         *  戻り値のStatusがtrueの場合、会員番号のQRコードを表示する
         * ---------------------------------------------- */
        saveProce: async function(){
            // ローディング表示
            this.$store.commit("loading/setIsOpacityLoading", true);

            Promise.resolve()
                .then(function(){
                    return new Promise(function(fulfilled, rejected){
                        // サブ画面が設定されている場合描画
                        if(this.confirmation_page_list != undefined && this.confirmation_page_list.length > 0){
                            if(this.sub_count < 0){
                                // 表示
                                this.sub_show = true;
                                this.main_show = false;
                            }
                            this.sub_count++;

                            // 存在チェック
                            if(this.confirmation_page_list[this.sub_count] != undefined && this.confirmation_page_list[this.sub_count].ConfirmPage != undefined){
                                // 表示する値変更
                                this.confirmation_page = this.confirmation_page_list[this.sub_count].ConfirmPage;
                                return fulfilled(false);
                            }else{
                                // 表示
                                this.sub_show = false;
                                this.sub_count = -1;
                            }
                        }
                        return fulfilled(true);
                    }.bind(this))
                }.bind(this))
                .then(confirmation_check => {
                    // サブ画面の表示フラグ
                    if(confirmation_check == false){
                        // イベント作成
                        this.htmlEventSet('addHtmlSub');
                        return 'confirmation';
                    }else{
                        // 確認項目保存API実行
                        return this.saveData();
                    }
                }).then(check => {
                    // サブ画面表示時は確認項目保存APIのチェックの結果は飛ばす
                    if(check != 'confirmation'){
                        if(check == true){
                            // 表示コード生成 (両方表示)
                            //if(this.make_display_code == '0'){
                                // バーコード
                                this.makeDisplayBarCode(this.member_number);
                            //}else{
                                // QRコード
                                this.makeDisplayQrCode(this.member_number);
                            //}
                            this.main_show = false;
                            this.is_show = true;
                        }else{
                            // 最初の画面に戻る
                            this.main_show = true;
                        }
                    }
                }).then(function(){
                    // ローディング削除
                    this.$store.commit("loading/setIsOpacityLoading", false);
                }.bind(this));

        },
        /** ----------------------------------------------
         * 確認項目保存API
         * ---------------------------------------------- */
        saveData: function (){
            var list = [];
            // 入力値チェック
            if(this.general_item_list !== undefined){
                for(var item in this.general_item_list){
                    if(item == undefined){
                        this.show_error = true;
                        this.error_message = "必須項目を入力・選択してください。";
                        this.error_level = "notice";
                        return false;
                    }
                    if(this.general_item_list.hasOwnProperty(item)) {
                        var val = this.general_item_list[item];

                        if(val == undefined || val == ''){
                            this.show_error = true;
                            this.error_message = "必須項目を入力・選択してください。";
                            this.error_level = "notice";
                            return false;
                        }

                        // 格納
                        list.push({
                            'GeneralItemName' : item,
                            'GeneralItemValue' : val
                        });
                    }
                }
            }

            // 確認ページのリスト
            var confirmation_page_return = [];
            confirmation_page_return.push({'ConfirmPage' : this.reservation_info});
            // 存在した場合追加
            if(this.confirmation_page_list != null){
                for(var i = 0; i < this.confirmation_page_list.length; i++){
                    confirmation_page_return.push(this.confirmation_page_list[i]);
                }
            }

            // 送信データ
            var postData = {
                "OfficeCode" : this.api_office_code,
                "WebMemberID" : this.member_number,
                "ConfirmationPageList" : confirmation_page_return,
                "GeneralItemList" : list,
            };

            return new Promise(function(resolve){
                // APIでデータ送信
                this.$apollo.query({
                    query: GET_API,
                    variables: {
                        url: this.save_api_url_all,
                        key: this.api_key,
                        data: JSON.stringify(postData),
                    }
                })
                // JSON型で取得
                .then(response => {
                    var data = response.data.GetMypageVisitApi.data;
                    return JSON.parse(data);
                })
                .then(data => {
                    if(data.Result.Status == '1'){

                        // 表示コード種類設定
                        //this.make_display_code = '0';

                        // Promiseに停止判定を送る
                        return resolve(true);

                    // メッセージがある場合
                    }else if(data.Result.Message !== undefined && data.Result.Message !== null){
                        // メッセージ表示
                        this.show_error = true;
                        this.error_message = data.Result.Message;
                        this.error_level = "notice";
                        // Promiseに停止判定を送る
                        return resolve(false);

                    // その他（システムエラー・サーバーエラー等）
                    }else{
                        // メッセージ表示
                        this.show_error = true;
                        this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                        this.error_level = "crit";
                        // Promiseに停止判定を送る
                        return resolve(false);
                    }
                })
                .catch((e) => {
                    console.log(e)  //エラーをキャッチし表示
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                    this.error_level = "crit";
                    return resolve(false);
                });

            }.bind(this));
        },
        /** ----------------------------------------------
         * 描画した画面にある入力欄やボタンの処理を作成する
         * ---------------------------------------------- */
        htmlEventSet: function(htmlName){
            // 格納したHTMLにアクションを追加
            let getHtml = this.$refs[htmlName];
            let gettingName = 'GeneralItemList.';
            let getdom = getHtml.querySelectorAll('[name *= "'+ gettingName +'"]');
            if(getdom.length > 0){
                getdom.forEach(function (item) {
                    // チェンジイベント
                    item.addEventListener('change', function(event){
                        var getNode = event.target.nodeName,
                            getType = event.target.type,
                            getVal  = event.target.value,
                            getNameAll = event.target.name,
                            getShowName = event.target.dataset.show,
                            getName = getNameAll.replace(gettingName, '');

                        // INPUT
                        if(getNode == 'INPUT'){
                            // 値を更新
                            this.general_item_list[getName] = getVal;

                            // 入力欄が空の場合
                            if(getType == 'text' && (getVal == '' || getVal == undefined)){
                                getShowName = '';
                            }

                            // ラジオボタン
                            if(getType == 'radio'){
                                // 画面に反映
                                getHtml.querySelectorAll('[name *= "'+ getNameAll +'"]').forEach(function (eveItem) {
                                    eveItem.closest('label').classList.remove("active");
                                });
                                event.target.closest('label').classList.add("active");
                            }
                        // TEXTAREA
                        }else if(getNode == 'TEXTAREA'){
                            // 値を更新
                            this.general_item_list[getName] = getVal;

                            // 入力欄が空の場合
                            if(getVal == '' || getVal == undefined){
                                getShowName = '';
                            }
                        }

                        // 確認部分に表示
                        if(getHtml.querySelector('[id="'+ getNameAll +'"]') !== undefined &&
                            getHtml.querySelector('[id="'+ getNameAll +'"]') !== null ){

                            // 表示用の値が設定されている場合
                            if(getShowName != undefined && getShowName != ''){
                                getHtml.querySelector('[id="'+ getNameAll +'"]').innerHTML = getShowName;
                            }else{
                                getHtml.querySelector('[id="'+ getNameAll +'"]').innerHTML = getVal;
                            }
                        }

                    // bind(this)とすることでthisを固定する
                    }.bind(this));

                    // 初期値設定
                    var getNode = item.nodeName,
                        getType = item.type,
                        getName = item.name.replace(gettingName, '');

                    if(this.general_item_list[getName] !== undefined){
                        // INPUT
                        if(getNode == 'INPUT'){
                            if(getType == 'radio'){
                                // ボタンクリック
                                if(item.value == this.general_item_list[getName]){
                                    item.click();
                                };
                            }else if(getType == 'text'){
                                // 値を更新
                                item.value = this.general_item_list[getName];
                            }
                        // TEXTAREA
                        }else if(getNode == 'TEXTAREA'){
                            // 値を更新
                            item.textContent = this.general_item_list[getName];
                        }
                    }
                }.bind(this));
            };
        },
    },
}
</script>

